<template>
  <div class="main-wrap">
    <action-bar title="会员资讯" :left="true" @back="back"></action-bar>
    <ul class="nav">
      <li class="active" @click="goto('/home/user')">会员资讯</li>
      <li @click="goto('/home/password')">修改密码</li>
      <li @click="goto('/home/message')">消息中心</li>
      <li @click="goto('/home/account')">资金明细</li>
    </ul>

    <div class="content">
      <ul>
        <li>账号:{{userinfo.username}}</li>
        <li>会员名称:{{userinfo.nickname}}</li>
        <li>账号状态:启用</li>
        <li v-if="userinfo.status==3">信用额度:冻结</li>
        <li v-else>信用额度:{{userinfo.credit_limit}}</li>
        <li v-if="userinfo.status==3">信用余额:冻结</li>
        <li v-else>信用余额:{{userinfo.credit_balance}}</li>
        <li>所属盘口:{{userinfo.market|formatMarket}}盘</li>
        <li>最小投注额:{{minBet}}</li>
        <li class="red">注:以下为退水与限额信息表</li>
      </ul>

      <table width="100%">
        <tbody>
          <tr>
            <th>彩种</th>
            <th>玩法</th>
            <th>单注最高</th>
            <th>单项最高</th>
            <th>退水(%)</th>
          </tr>
          <tr v-for="p in profile " :key="p.id">
            <td>{{p.lottery_name}}</td>
            <td>{{p.played_name}}</td>
            <td>{{p.total_limit}}</td>
            <td>{{p.single_limit}}</td>
            <td>
              <span class="market" v-if="userinfo.market.indexOf('A')!=-1">A:{{p.rebate_a}}</span>
              <span class="market" v-if="userinfo.market.indexOf('B')!=-1">B:{{p.rebate_b}}</span>
              <span class="market" v-if="userinfo.market.indexOf('C')!=-1">C:{{p.rebate_c}}</span>
              <span class="market" v-if="userinfo.market.indexOf('D')!=-1">D:{{p.rebate_d}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ActionBar from "@/components/action-bar";
import { getProfile } from "@/service/user";
export default {
  data() {
    return {
      userinfo: {},
      profile: {},
      minBet:''
    };
  },
  created() {
    getProfile().then(res => {
      if (res.result == "ok") {
        this.profile = res.data.profile;
        this.userinfo = res.data.userinfo;
        this.minBet = res.data.minbet;
        //console.log("这里用户信息", res);
      }
      //console.log(111, res);
    });
  },
  filters: {
      formatMarket: function (value) {
        return value.join(",");
      }
  },
  methods: {
      back(){
          this.$router.push('/home/main');
      },
      goto(url){
           this.$router.push(url);
      }
  },

  components: {
    ActionBar
  }
};
</script>

<style scoped lang="less">
.main-wrap {
  .nav {
    background-color: #ffffff;
    margin: 0;
    padding: 0;
    list-style-type: none;
    line-height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    font-size: 18px;
    li {
      width: 220px;
    }

    .active {
      border-bottom-color: #ba142b;
      border-bottom-width: 4px;
      color: #ba142b;
    }
  }
  .content {
    border-radius: 5px;
    margin: 20px 5px;
    height: auto;
    padding: 5px;
    background-color: #ffffff;

    font-size: 24px;
    li {
      height: 50px;
      font-size: 24px;
    }
  }
  table {
    border-collapse: collapse;
  }

  table,
  td,
  th {
    height: 50px;
    border: 1px solid #cccccc;
     text-align: center;
      padding-top: 20px;
  }
  th {
      background-color: #eeeeee;
     
  }
  .market{display:block}
}
</style>



// WEBPACK FOOTER //
// src/pages/home/user/index.vue